<template>
  <div>
    <section class="pt-5">
      <b-container class="my-5">
        <h1 class="text-secondary font-weight-bold">Games</h1>
        <p>Currently playable games:</p>
      </b-container>
    </section>
    <section class="py-5 bg-light">
      <b-container class="py-5">
        <b-row class="pb-5" cols-md="2" cols="1">
          <b-col>
            <img
              src="@/assets/uno.png"
              class="img-fluid"
              style="max-height: 200px"
              alt
            />
          </b-col>
          <b-col class="d-flex flex-column">
            <h2 class="text-dark font-weight-bold">Uno!</h2>
            <p>
              Built this game in 2 weekends for playing online with friends.
            </p>
            <p>
              Bunch of nice websockets and animation. Built with React and Node.
              Wanted to build more options but haven't gotten to that yet.
            </p>
            <span
              ><a
                class="mt-auto ml-auto mb-3"
                href="https://github.com/WuttiFrutti/online-uno"
                >Github</a
              >
              -
              <a
                class="mt-auto ml-auto mr-3 mb-3"
                href="http://uno.wuttifrutti.nl"
                >Site</a
              ></span
            >
          </b-col>
        </b-row>
      </b-container>
    </section>
    <round-section-border
      class="section-border-top"
      fill="#7957d5"
    ></round-section-border>
    <section class="pb-5 bg-primary">
      <b-container class="py-5 mb-5">
        <b-row cols-md="2" cols="1">
          <b-col>
            <h2 class="text-light font-weight-bold">BattleShip</h2>
            <p class="text-light">
              One weekend project for friends again. This time with Material UI.
              Still React and node though. The server is just a 100 line
              websocket handler.
            </p>
            <span class="text-secondary"
              ><a
                class="text-secondary mt-auto ml-auto mb-3"
                href="https://github.com/WuttiFrutti/battleship"
                >Github</a
              >
              -
              <a
                class="text-secondary mt-auto ml-auto mr-3 mb-3"
                href="http://game.wuttifrutti.nl"
                >Site</a
              ></span
            >
          </b-col>
          <b-col
            ><img
              src="@/assets/battleship.png"
              class="img-fluid"
              style="max-height: 200px"
              alt
          /></b-col>
        </b-row>
      </b-container>
    </section>
    <round-section-border
      class="section-border-top"
      fill="#fff"
    ></round-section-border>
    <section class="pb-5 mb-5">
      <b-container class="py-5">
        <b-row class="pt-5" cols-md="2" cols="1">
          <b-col></b-col>
          <b-col class="d-flex flex-column">
            <h2 class="font-weight-bold">More games</h2>
            <p>
              I have built a couple more games. These games are currently not hosted online and should be installed on your PC in order to work.
              <br> All of these games can be found on my Github.
            </p>
            <a
              class="mt-auto ml-auto mr-3 mb-3"
              href="https://github.com/WuttiFrutti"
              >Github</a
            >
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import RoundSectionBorder from "@/components/svg/RoundSectionBorder";

export default {
  components: { RoundSectionBorder },
  beforeRouteEnter(to, from, next) {
    next((vm) => vm.$emit("navsetting", false));
  },
};
</script>
